export default function StepSpacer() {
  return <div className='dataloom-step__spacer'></div>;
}
